var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg6({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152.542,
    height: 88.273,
    viewBox: "0 0 152.542 88.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17469",
    "data-name": "Group 17469",
    transform: "translate(-805.229 -148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15586",
    "data-name": "Group 15586",
    transform: "translate(805.229 148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14836",
    "data-name": "Group 14836",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14831",
    "data-name": "Group 14831",
    transform: "translate(6.228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8542",
    "data-name": "Path 8542",
    d: "M48.008,124.2S34.734,66.473,46.019,52.65c13.274-16.258,46.187-21.805,62.211-10.235S166.7,38.6,177.41,54.626s-2.74,69.922-2.74,69.922Z",
    transform: "translate(-41.472 -36.275)",
    fill: "rgba(16,135,87,0.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14832",
    "data-name": "Group 14832",
    transform: "translate(73.919 20.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8543",
    "data-name": "Path 8543",
    d: "M393.766,138.533c-1.976-.305-1.056-1.609-2.545-2.166-1.309-.49-3.024.053-4.323.357-2.728.639-1.84-1.085-4.278-1.525-1.978-.357-3.284,1.035-4.635,1.587-1.989.812-1.66-.745-3.855-.729a6.053,6.053,0,0,0-3.829,1.9c-1.1.961-2.3.964-4.28,1.066-1.818.094-3.529.8-.77.966,1.5.088,23.749-.082,28.676-.276,2.207-.087,3.24-.242,3.458-.853C397.677,138.047,394.942,138.715,393.766,138.533Z",
    transform: "translate(-363.803 -135.14)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14833",
    "data-name": "Group 14833",
    transform: "translate(0 32.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8544",
    "data-name": "Path 8544",
    d: "M38.974,195.756c-1.795-.257-.974-1.449-2.329-1.939-1.192-.431-2.742.078-3.917.367-2.467.607-1.68-.966-3.9-1.341-1.8-.3-2.968.972-4.187,1.485-1.8.756-1.513-.659-3.5-.622a5.49,5.49,0,0,0-3.453,1.763c-.991.882-2.079.9-3.87,1.009-1.648.1-3.192.763-.688.883,1.361.065,21.536-.312,26-.537,2-.1,2.935-.252,3.128-.808C42.516,195.276,40.043,195.909,38.974,195.756Z",
    transform: "translate(-11.813 -192.797)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14834",
    "data-name": "Group 14834",
    transform: "translate(120.49 28.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8545",
    "data-name": "Path 8545",
    d: "M614.14,173.4c-1.884-.336-1-1.776-2.423-2.39-1.248-.54-2.885.059-4.124.4-2.6.706-1.753-1.2-4.077-1.682-1.886-.393-3.135,1.144-4.423,1.753-1.9.9-1.582-.822-3.676-.8-1.692.015-2.942,1.383-3.656,2.1-1.054,1.061-2.2,1.064-4.084,1.177-1.734.1-3.367.887-.736,1.066,1.43.1,22.65-.1,27.351-.315,2.105-.1,3.09-.268,3.3-.943C617.871,172.86,615.261,173.6,614.14,173.4Z",
    transform: "translate(-585.561 -169.657)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14835",
    "data-name": "Group 14835",
    transform: "translate(11.343 8.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8546",
    "data-name": "Path 8546",
    d: "M96.523,78.965c-5.089.081-2.246-2.181-4.407-2.6s-3.616,1.11-5.669.308c-2.178-.851-3.2-2.355-5.911-1.793-.926.193-2.307,1.848-3.325,1.855-1.207.008-1.247-1.413-2.448-1.274-2.467.285-2.611,1.352-4.03,2.406a7.829,7.829,0,0,1-4.091,1.376c-.8-.046-1.769,1.34,1.209,1.341,5.3,0,23.023-.367,29.207-.3C97.805,80.288,99.623,78.916,96.523,78.965Z",
    transform: "translate(-65.825 -74.758)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16124",
    "data-name": "Group 16124",
    transform: "translate(-548.1 -625.615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14865",
    "data-name": "Group 14865",
    transform: "translate(576.531 704.358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14856",
    "data-name": "Group 14856",
    transform: "translate(6.066 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8561",
    "data-name": "Path 8561",
    d: "M78.185,414.593c.392-.586.621-1.311,1.21-1.688.854-.547,1.959-.091,2.919.236a7.455,7.455,0,0,0,4.1.3,2.048,2.048,0,0,1,1.728.125,5.164,5.164,0,0,0,2.242.408c3.192-.22,5.376-4.193,8.562-3.892,2.394.227,3.97,2.816,6.328,3.292,2.719.549,5.052-1.835,7.63-2.859,6.309-2.507,13.194,3.36,19.9,2.292,3.859-.615,14.692,5.636.739,5.916-7.561.152-14.569-.155-22.131-.152-6.006,0-12.163.225-18.168.227-5.139,0-9.213-.16-14.35-.3a35.543,35.543,0,0,0-7.377-.085,1.23,1.23,0,0,1-.343-.188.969.969,0,0,1-.137-1.109,2.551,2.551,0,0,1,2.039-1.316,22.606,22.606,0,0,1,2.533-.028,3.256,3.256,0,0,0,2.32-.844A2.582,2.582,0,0,0,78.185,414.593Z",
    transform: "translate(-70.926 -409.883)",
    fill: "#4c7722"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14857",
    "data-name": "Group 14857",
    transform: "translate(48.938 3.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8562",
    "data-name": "Path 8562",
    d: "M310.317,429.912c-.022.038.87-.031,1.258.34.591.564,1.669,2.97,1.107,3.9C312.624,432.24,310.312,429.895,310.317,429.912Z",
    transform: "translate(-310.317 -429.911)",
    fill: "#80af1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14858",
    "data-name": "Group 14858",
    transform: "translate(20.149 1.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8563",
    "data-name": "Path 8563",
    d: "M152.652,417.306c.027.047-1.066-.038-1.541.416-.723.691-2.045,3.638-1.356,4.772C149.827,420.157,152.658,417.285,152.652,417.306Z",
    transform: "translate(-149.562 -417.305)",
    fill: "#80af1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14861",
    "data-name": "Group 14861",
    transform: "translate(66.339 3.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14859",
    "data-name": "Group 14859"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8564",
    "data-name": "Path 8564",
    d: "M408.479,432.265a4.318,4.318,0,0,1-.981-3.047C408.685,430.051,408.479,432.265,408.479,432.265Z",
    transform: "translate(-407.476 -429.218)",
    fill: "#80af1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14860",
    "data-name": "Group 14860",
    transform: "translate(1.176 0.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8565",
    "data-name": "Path 8565",
    d: "M416.546,430.076c.021.038-.864-.031-1.249.337-.586.56-1.657,2.949-1.1,3.869C414.256,432.387,416.551,430.059,416.546,430.076Z",
    transform: "translate(-414.041 -430.075)",
    fill: "#80af1b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14862",
    "data-name": "Group 14862",
    transform: "translate(51.629 4.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8566",
    "data-name": "Path 8566",
    d: "M327.462,433.845c.018.032-.731-.026-1.057.285-.5.474-1.4,2.5-.93,3.275C325.523,435.8,327.466,433.831,327.462,433.845Z",
    transform: "translate(-325.342 -433.845)",
    fill: "#80af1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14863",
    "data-name": "Group 14863",
    transform: "translate(10.558 3.043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8567",
    "data-name": "Path 8567",
    d: "M96.013,427.5a1.961,1.961,0,0,1,.689.22,3.48,3.48,0,0,1,1.7,3.083A13.038,13.038,0,0,0,96.013,427.5Z",
    transform: "translate(-96.013 -427.499)",
    fill: "#80af1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14864",
    "data-name": "Group 14864",
    transform: "translate(0 6.688)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_150",
    "data-name": "Ellipse 150",
    cx: 39.503,
    cy: 1.421,
    rx: 39.503,
    ry: 1.421,
    fill: "#774d1c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17420",
    "data-name": "Group 17420",
    transform: "translate(1049.071 15.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17415",
    "data-name": "Group 17415",
    transform: "translate(-151.898 154.088)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17413",
    "data-name": "Group 17413",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149002",
    "data-name": "Rectangle 149002",
    width: 2.491,
    height: 20.817,
    transform: "translate(5.878 33.57)",
    fill: "#108757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18129",
    "data-name": "Path 18129",
    d: "M-118.935,154.088l-.018.006-.019-.006s-6.518,1.992-6.852,5.886c-.368,4.286-.187,12.356-.187,12.356H-111.9s.181-8.071-.187-12.356C-112.418,156.08-118.935,154.088-118.935,154.088Z",
    transform: "translate(126.056 -154.088)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18130",
    "data-name": "Path 18130",
    d: "M-116.7,165.259a7.276,7.276,0,0,0-.759-2.932,7.269,7.269,0,0,0-.76,2.932c-.092,1.743-.638,8.757-.638,8.757a2.715,2.715,0,0,1,.456,1.708c-.061,1.038-.274,3.191-.274,4.675s-.03,6.049-.03,6.049h2.491s-.03-4.564-.03-6.049-.212-3.636-.274-4.675a2.714,2.714,0,0,1,.456-1.708S-116.611,167-116.7,165.259Z",
    transform: "translate(124.586 -155.771)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149003",
    "data-name": "Rectangle 149003",
    width: 2.491,
    height: 3.533,
    transform: "translate(5.878 30.676)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149004",
    "data-name": "Rectangle 149004",
    width: 7.932,
    height: 1.486,
    transform: "translate(3.053 65.481)",
    fill: "#108757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18131",
    "data-name": "Path 18131",
    d: "M-117.053,226.391V222.44h-2.488v3.951a3.606,3.606,0,0,1-1.5,2.393c-1.614,1.5-1.892,3.729-1.892,6.234h1s-.111-3.117.779-4.286a3.137,3.137,0,0,1,2.858-1.392,3.138,3.138,0,0,1,2.859,1.392c.89,1.169.779,4.286.779,4.286h1c0-2.5-.278-4.731-1.892-6.234A3.606,3.606,0,0,1-117.053,226.391Z",
    transform: "translate(125.419 -168.053)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17414",
    "data-name": "Group 17414",
    transform: "translate(16.054 6.23)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149005",
    "data-name": "Rectangle 149005",
    width: 2.491,
    height: 31.244,
    transform: "translate(9.204 16.913)",
    fill: "#108757"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149006",
    "data-name": "Rectangle 149006",
    width: 2.491,
    height: 3.533,
    transform: "translate(9.204 14.118)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149007",
    "data-name": "Rectangle 149007",
    width: 7.932,
    height: 1.486,
    transform: "translate(6.379 59.25)",
    fill: "#108757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18132",
    "data-name": "Path 18132",
    d: "M-88.926,226.391V222.44h-2.489v3.951a3.6,3.6,0,0,1-1.5,2.393c-1.614,1.5-1.893,3.729-1.893,6.234h1s-.111-3.117.78-4.286a3.137,3.137,0,0,1,2.858-1.392,3.137,3.137,0,0,1,2.858,1.392c.891,1.169.78,4.286.78,4.286h1c0-2.5-.278-4.731-1.893-6.234A3.6,3.6,0,0,1-88.926,226.391Z",
    transform: "translate(100.619 -174.283)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18133",
    "data-name": "Path 18133",
    d: "M-81.817,161.918a.481.481,0,0,0-.479.479v2.678h-.981V162.4a.481.481,0,0,0-.48-.479.481.481,0,0,0-.479.479v2.678h-.958V162.4a.481.481,0,0,0-.479-.479.481.481,0,0,0-.479.479v2.678h-1.118V162.4a.481.481,0,0,0-.479-.479.481.481,0,0,0-.479.479v2.678h-.959V162.4a.481.481,0,0,0-.479-.479.481.481,0,0,0-.479.479v2.678h-1.069V162.4a.481.481,0,0,0-.479-.479.481.481,0,0,0-.479.479v2.678h-.98V162.4a.481.481,0,0,0-.479-.479.481.481,0,0,0-.479.479v2.678h-.958V162.4a.481.481,0,0,0-.48-.479.481.481,0,0,0-.479.479v2.678h-1.118V162.4a.481.481,0,0,0-.479-.479.481.481,0,0,0-.479.479v2.678h-.958V162.4a.481.481,0,0,0-.479-.479.481.481,0,0,0-.48.479v2.678h-1.131V162.4a.481.481,0,0,0-.48-.479.481.481,0,0,0-.479.479v5.388h20.773V162.4A.481.481,0,0,0-81.817,161.918Z",
    transform: "translate(102.11 -161.918)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18134",
    "data-name": "Path 18134",
    d: "M-87.861,167.652h-3.61a.786.786,0,0,0-.419,1.49c.369.177.978.346.978,1.171v6.894h2.491v-6.894c0-.825.609-.994.978-1.171A.786.786,0,0,0-87.861,167.652Z",
    transform: "translate(100.116 -163.089)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18135",
    "data-name": "Path 18135",
    d: "M-91.479,168.3a.252.252,0,0,0-.252.253.252.252,0,0,0,.252.253.253.253,0,0,0,.253-.253A.253.253,0,0,0-91.479,168.3Z",
    transform: "translate(99.99 -163.223)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18136",
    "data-name": "Path 18136",
    d: "M-86.812,168.3a.253.253,0,0,0-.253.253.253.253,0,0,0,.253.253.253.253,0,0,0,.253-.253A.253.253,0,0,0-86.812,168.3Z",
    transform: "translate(99.036 -163.223)",
    fill: "#b2b2b2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17419",
    "data-name": "Group 17419",
    transform: "translate(-228.071 181.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18137",
    "data-name": "Path 18137",
    d: "M-151.974,178.857a3.981,3.981,0,0,0-3.632-2.763,3.984,3.984,0,0,0-3.71,2.089,4.529,4.529,0,0,0-3.85-1.492,3.743,3.743,0,0,0-3.067,1.794s-.514-2.938-3.1-3.3a3.093,3.093,0,0,0-3.685,1.955s-.792-2.884-4.473-2.41a5.967,5.967,0,0,0-3.549,1.963,3.727,3.727,0,0,0-4.211-1.508c-2.685.879-1.416,3.927-1.416,3.927s-.375-.927-3.21-.625-3.581,3.262-3.581,3.262H-147.6a7.1,7.1,0,0,0-1.54-2.636C-150.182,178.1-151.974,178.857-151.974,178.857Z",
    transform: "translate(221 -174.676)",
    fill: "#7e3422"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17418",
    "data-name": "Group 17418",
    transform: "translate(0 3.602)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_176",
    "data-name": "Ellipse 176",
    cx: 9.734,
    cy: 9.734,
    r: 9.734,
    transform: "translate(51.278 15.963)",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17416",
    "data-name": "Group 17416",
    transform: "translate(26.474 2.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18138",
    "data-name": "Path 18138",
    d: "M-193.014,190.367c6.3,2.006,19.39,6.1,21.232,6.109,2.483.008,4.458-2.16,7.109-4.461,3.468-3.012,9.1-8.59,9.1-8.59s2.308-.232,5.22-.532l-44.445.828S-193.818,188.164-193.014,190.367Z",
    transform: "translate(194.8 -182.893)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18139",
    "data-name": "Path 18139",
    d: "M-155.116,183.425s-5.63,5.578-9.1,8.59c-2.65,2.3-4.625,4.469-7.109,4.461-1.842-.006-14.934-4.1-21.232-6.109.053.143.1.278.154.4a5.727,5.727,0,0,0,3.893,3.221c4.477,1.489,11.155,3.445,15.366,4.326a8.526,8.526,0,0,0,6.868-1.343c4.147-2.887,19.6-14.078,19.6-14.078H-149.9C-152.808,183.194-155.116,183.425-155.116,183.425Z",
    transform: "translate(194.342 -182.893)",
    fill: "#515151"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_18140",
    "data-name": "Path 18140",
    d: "M-153,203.648a6.246,6.246,0,0,0-6.246,6.246A6.246,6.246,0,0,0-153,216.14a6.247,6.247,0,0,0,6.246-6.246A6.246,6.246,0,0,0-153,203.648Z",
    transform: "translate(214.009 -184.197)",
    fill: "#d8720e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18141",
    "data-name": "Path 18141",
    d: "M-152.737,204.922a5.233,5.233,0,0,0-5.233,5.232,5.233,5.233,0,0,0,5.233,5.233,5.232,5.232,0,0,0,5.232-5.233A5.232,5.232,0,0,0-152.737,204.922Z",
    transform: "translate(213.749 -184.458)",
    fill: "#e88416"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18142",
    "data-name": "Path 18142",
    d: "M-153.019,206.8c-.088-.057-10.662-4.226-20.184-7.449,8.572-6.078,16.559-11.826,17.2-12.286a.93.93,0,0,0,.212-1.3.931.931,0,0,0-1.3-.212c-.166.119-9.073,6.53-18.3,13.065-.5-.163-.989-.323-1.472-.477-2.185-.7-4.57-1.416-7.1-2.176-5.127-1.544-10.428-3.141-14.764-4.775-2.215-.835-6.81-3.813-10.5-6.206a53.457,53.457,0,0,0-6.7-4.037,14.643,14.643,0,0,0-4.636-.7v1.858a12.724,12.724,0,0,1,4,.6,62.775,62.775,0,0,1,6.321,3.847c3.963,2.568,8.453,5.481,10.856,6.386,1.124.423,2.311.843,3.538,1.26l-4.893,12.44c-1.35,3.437-1.2,6.283.389,7.614a3.383,3.383,0,0,0,2.24.761,9.014,9.014,0,0,0,4.579-1.632c3.07-1.895,10.794-7.282,18.446-12.7,2.691.894,5.517,1.883,8.2,2.848-.174,1.21-.672,2.773.987,3.186,1.125.281,1.81-.913,2.577-1.887,5.243,1.933,9.241,3.5,9.295,3.533a.923.923,0,0,0,.5.149.929.929,0,0,0,.782-.426A.93.93,0,0,0-153.019,206.8Zm-41.486,5c-2.116,1.306-3.853,1.689-4.65,1.025-.754-.63-1-2.577.15-5.506l4.929-12.531c3.082,1.009,6.365,2,9.579,2.966,2.517.758,4.894,1.474,7.065,2.167l.142.045C-184.551,205.093-191.655,210.037-194.5,211.8Z",
    transform: "translate(226.537 -179.417)",
    fill: "#dc4437"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18143",
    "data-name": "Path 18143",
    d: "M-151.565,210.654a.672.672,0,0,0-.672.672.672.672,0,0,0,.672.672.672.672,0,0,0,.672-.672A.672.672,0,0,0-151.565,210.654Z",
    transform: "translate(212.578 -185.629)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18144",
    "data-name": "Path 18144",
    d: "M-147.9,182.6h-49.286a1.144,1.144,0,0,0-1.165,1.115v.423h51.617v-.423A1.145,1.145,0,0,0-147.9,182.6Z",
    transform: "translate(221.999 -179.896)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17417",
    "data-name": "Group 17417"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149008",
    "data-name": "Rectangle 149008",
    width: 6.509,
    height: 2.499,
    transform: "translate(0 0.579)",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149009",
    "data-name": "Rectangle 149009",
    width: 0.743,
    height: 3.469,
    transform: "translate(5.974)",
    fill: "#6b6b6b"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg6);
export default __webpack_public_path__ + "static/media/img6.5f24426708372d9d2bc2139c8ef7041c.svg";
export { ForwardRef as ReactComponent };